import { z } from 'zod';

export const privacySettingsScheme = z.object({
  IsManualVerifiedFriend: z.number().pipe(z.coerce.boolean()),
  IsManualVerifiedGroup: z.number().pipe(z.coerce.boolean()),
});

export type PrivacySettings = z.infer<typeof privacySettingsScheme>;

export const privacySettingTypeMap = {
  IsManualVerifiedFriend: 1,
  IsManualVerifiedGroup: 2,
} as const;
